import { render, staticRenderFns } from "./ApprovalFail.vue?vue&type=template&id=6f8d00a8&scoped=true"
import script from "./ApprovalFail.vue?vue&type=script&lang=js"
export * from "./ApprovalFail.vue?vue&type=script&lang=js"
import style0 from "./ApprovalFail.vue?vue&type=style&index=0&id=6f8d00a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d00a8",
  null
  
)

export default component.exports